import Vue from 'vue';
import Vuex from 'vuex';
import Demo from './demo';
import UserInfo from './user-info';

Vue.use(Vuex);
// 创建 store 实例
export default new Vuex.Store({
	modules: {
		demo: Demo,
		userInfo: UserInfo,
	}
});



// WEBPACK FOOTER //
// ./src/vuex/index.js